/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ApprovalsModalContainer as ApprovalsModal } from './ApprovalsModal.container';
